import { Modal, useHooks } from '@everlywell/leaves';
import React, { useContext, useEffect } from 'react';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { MEMBERSHIP_CARD } from 'utils/constants/dataTest';
import { UserSettingsContext } from 'utils/hooks/useAccountSettings/context';

import ShippingSettings from '../ShippingSettings';
import CONTENT from './content';
import * as S from './styles';

type CreditRedemptionModal = {
  open: boolean;
  confirmOrder: () => void;
  openHandler: (opened: boolean) => void;
};

const CreditRedemptionModal = ({
  open,
  confirmOrder,
  openHandler,
}: CreditRedemptionModal) => {
  const { shippingAddress, savedShippingInfo, resetState } =
    useContext(UserSettingsContext);
  const onConfirmOrder = async () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.LABELS.ORDER_MODAL_CONFIRM_ORDER.label,
        description: ANALYTICS.LABELS.ORDER_MODAL_CONFIRM_ORDER.description,
      },
    });
    confirmOrder();
  };

  useHooks.useDisableScroll(open);

  useEffect(() => {
    if (!open) resetState && resetState();
  }, [open]);

  return (
    <Modal open={open} openHandler={openHandler} persist>
      <S.Title>{CONTENT.modal.title}</S.Title>
      <S.Description>{CONTENT.modal.message}</S.Description>

      <S.Address>
        <ShippingSettings smallSave>
          {(editing: boolean) => (
            <>
              <div>
                {savedShippingInfo && (
                  <S.SavedBlurb>
                    <S.InfoIcon>
                      <S.Icon />
                    </S.InfoIcon>
                    <S.Content>{CONTENT.blurb}</S.Content>
                  </S.SavedBlurb>
                )}
              </div>
              <S.Button
                appearance="primary"
                onClick={onConfirmOrder}
                data-testid={MEMBERSHIP_CARD.ORDER_TEST_MODAL}
                // @ts-ignore
                disabled={!shippingAddress?.address1 || editing}
              >
                Order
              </S.Button>
            </>
          )}
        </ShippingSettings>
      </S.Address>
    </Modal>
  );
};

export default CreditRedemptionModal;
